import PropTypes        from 'prop-types';
import React            from 'react';
import * as S           from './change-plan-acme.module.scss';

import { ModalWrapper }       from '../../modal-wrapper';
import { PlanBoxAcme }        from './plan-box-acme';
import { useGlobalCtx }       from '../../../../context/ctx-hook';
import * as ProductSelectors  from '../../../../context/selectors/product-selectors';
import { SingleProductRow }  from '../../../pages/subscriptions/unified-sub-tile/product-single-row';


const PRORATE_UPG_MSG = 'You will be charged a prorated amount based on the time remaining on your subscription.';
const PRORATE_DWNGRD_MSG = 'Your subscription will automatically renew to this plan at the end of your current term.';

const ChangePlanAcme = ({onClose, ctx: {product}}) => {
  const {state} = useGlobalCtx();
  const SUB = ProductSelectors.getSubscription(state, product);
  const SIMP_PLANS = ProductSelectors.getChangePlanProductOfferings(product, state.country);
  const PLAN_INDEX = SIMP_PLANS.findIndex(({ uriName }) => uriName === SUB.tierUriName);
  const PENDING_DOWNGRADE = SUB.renewalTierUriName ? SUB.renewalTierUriName !== SUB.tierUriName : false;

  if (!SUB?.active) {
    onClose();
  }

  return (
    <ModalWrapper heading="Change Plan" onClose={onClose} className={S.wrapper}>
      <div className={S.qknCPWrapper} data-testid={'SIMP_CHANGE_PLAN_CURRENT_PLAN'}>
        <div>
          <div className={S.label}>Your current plan</div>
          <div className={S.prodRowContain}>
            <SingleProductRow sub={SUB} isModal={true} />
          </div>
        </div>

        <div className={S.dash}/>

        <div>
          <div className={S.label}>Other Options</div>
          <div className={S.optionArea} data-testid={'SIMP_CHANGE_PLAN_OPTIONS_BOXES'}>
            {SIMP_PLANS.map(({uriName, sku, name}, i) => {
              if (uriName === SUB.tierUriName) return null;
              return (
                <PlanBoxAcme
                  key={sku}
                  name={name}
                  sku={sku}
                  country={state.country}
                  currentTierUri={SUB.tierUriName}
                  renewalTierUriName={SUB.renewalTierUriName}
                  uriName={uriName}
                  action={PLAN_INDEX > i ? 'UPGRADE' : 'DOWNGRADE'}
                  boxText={PLAN_INDEX > i ? PRORATE_UPG_MSG : PRORATE_DWNGRD_MSG}
                  data-testid={'SIMP_CHANGE_PLAN_PLAN_BOX'}
                />
              );
            })}
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};


ChangePlanAcme.displayName = 'ChangePlanAcme';
ChangePlanAcme.propTypes   = {
  onClose: PropTypes.func.isRequired,
  ctx:     PropTypes.shape({
    product: PropTypes.string.isRequired
  })
};

export { ChangePlanAcme };
